<template>
    <GestionBajasBloque />
  </template>
  <script>
  import GestionBajasBloque from "./components/GestionBajasBloque.vue";
  export default {
    name: "BajasBloque",
    components: { GestionBajasBloque }
  };
  </script>